import React from 'react'
import styles from "../css/Notes.module.css"
const EmptyResults = () => {
  return (
    <div data-testid = "empty-search" className = {`${styles.emptyContainer} ${styles.search}`}>
        <img 
          src = "/assets/notepadSearch.png"
          alt = "Empty Board"
          loading="lazy"
        />
        <div className = {styles.eyebrow}>No Matches Found</div>
        <div className = {styles.title}>Nothing <span>fits</span> your search.</div>
        <div className = {styles.desc}> Clear filters or broaden your search to see more.</div>
    </div>
  )
}

export default EmptyResults